/* eslint-disable */
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import VueExpand from "../directives/expand/VueExpand";
import BurgerMenu from "../vue/burger-menu/BurgerMenu.vue";
import SiteLanguage from "../vue/site-language/SiteLanguage.vue";
import InstagramCarousel from "scripts/vue/instagram-carousel/InstagramCarousel.vue";
import ScrollToTop from "scripts/vue/scroll-to-top/ScrollToTop.vue";
import * as insight from "../insight.js";
import StickyHeader from "../util/StickyHeader";
import axios from "axios";

// Setup axios globally
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Custom directive
Vue.directive("expand", VueExpand);

// Avoid multiple loads of Google Maps API
if (!window.GOOGLE_MAPS_API_INITIALIZED) {
  window.GOOGLE_MAPS_API_INITIALIZED = true;
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyBpITpxgGIo_f44skm6AUqrRSB8O1qZ-kQ',
      libraries: 'places,geometry',
      language: 'en',
    },
    installComponents: true,
  });
}

export default {
  init() {
    if (document.querySelector("#header")) {
      new Vue({
        el: "#header",
        name: "header",
        components: {
          BurgerMenu,
          SiteLanguage,
        },
      });
    }
    if (document.querySelector("#instagram")) {
      new Vue({
        el: "#instagram",
        name: "instagram",
        components: {
          InstagramCarousel,
        },
      });
    }
    if (document.querySelector("#scroll-to-top")) {
      new Vue({
        el: "#scroll-to-top",
        name: "scrollToTop",
        components: {
          ScrollToTop,
        },
      });
    }
  },
  finalize() {
    insight.trackEvents();
    StickyHeader("header");
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js